import Breadcrumbs from "components/Common/Breadcrumb";
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { MetaTags } from "react-meta-tags";
import {
  Col,
  Container,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import classNames from "classnames";
import ProductForm from "containers/product/ProductForm";
import {
  addNewProduct,
  clearProductNotify,
  getProductById,
} from "store/actions";
import { toastMessage } from "helpers/utils";

const AddNewProduct = props => {
  const { match, history } = props;

  const [activeTab, setActiveTab] = useState("1");

  const { addNewProduct, clearProductNotify, product } = props;
  const { item, loading, message } = product;

  useEffect(() => {
    if (message) {
      toastMessage(message);
      clearProductNotify();
    }
  }, [message]);

  const handleSubmit = data => {
    addNewProduct({
      history,
      data,
    });
  };

  const handleOnCancel = () => {
    history.push("/product");
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Add New Product | CR TechSoft</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs title="Home" backLink={"/product"} breadcrumbItem={``} />

          <Row>
            <Col md={12}>
              <Nav tabs>
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classNames({
                      active: activeTab === "1",
                    })}
                    onClick={() => {
                      setActiveTab("1");
                    }}
                  >
                    General
                  </NavLink>
                </NavItem>
              </Nav>

              <TabContent activeTab={activeTab}>
                <TabPane tabId="1">
                  <ProductForm
                    onSubmit={handleSubmit}
                    onCancel={handleOnCancel}
                  />
                </TabPane>
              </TabContent>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

AddNewProduct.propTypes = {
  product: PropTypes.object,
  item: PropTypes.object,
  loading: PropTypes.bool,
  history: PropTypes.object,
  match: PropTypes.object,
  addNewProduct: PropTypes.func,
  clearProductNotify: PropTypes.func,
};

const mapStateToProps = ({ product }) => {
  return {
    product,
  };
};

export default withRouter(
  connect(mapStateToProps, {
    addNewProduct,
    clearProductNotify,
  })(AddNewProduct)
);
